import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ProductsAnalyticsProvider } from '@client/analytics/context/products/ProductsAnalyticsContext';
import { EVENT_SOURCE } from '@client/analytics/types/types';
import { RemoteRecordHandler } from '@client/common/components/RemoteRecordHandler';
import { useDeviceType } from '@client/common/hooks';
import { SimilarProducts } from '@client/product/components/ProductData/SimilarProducts/SimilarProducts';
import { useFetchSimilarProducts } from '@client/product/hooks/useFetchSimilarProducts';
import { useSimilarProducts } from '@client/product/hooks/useSimilarProducts';

export const SimilarProductsContainer = (): ReactElement => {
  const fetchSimilarProducts = useFetchSimilarProducts();
  const similarProductsRecord = useSimilarProducts();
  const { sku } = useParams<{ sku: string }>();
  const deviceType = useDeviceType();

  useEffect(() => {
    fetchSimilarProducts(sku);
  }, [sku]);

  return (
    <RemoteRecordHandler remoteRecord={similarProductsRecord}>
      <ProductsAnalyticsProvider eventSource={EVENT_SOURCE.recommendations}>
        <SimilarProducts
          deviceType={deviceType}
        />
      </ProductsAnalyticsProvider>
    </RemoteRecordHandler>
  );
};
